<template>
  <div class="progress">
    <breadcrumb class="bread" :path="path" :name="name" :childPath="childPath" :childName="childName"></breadcrumb>
    <div class="main-row contain">
      <div class="col col-xlg-12 col-sm-12 progress-item">
        <h4 class="item-h4" style="float:left;">工作进展</h4>
        <template v-if="tableData.length>0">
          <el-table
              :data="tableData"
              style="width: 100%">
            <el-table-column
                pr prop="title"
                label=""
                show-overflow-tooltip
                style="text-align: left">
              <template slot-scope="scope">
                <router-link class="list-title" :to="'/detail/'+ scope.row.id+'/'+scope.row.type"
                             :detailId="scope.row.id">{{scope.row.title }}</router-link>
              </template>
            </el-table-column>
            <el-table-column
                prop="createTime"
                label=""
                width="100">
            </el-table-column>
          </el-table>

          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="totalPage">
          </el-pagination>
        </template>
        <el-empty description="没有找到数据" style="width: 20%;margin: 0 auto" v-else></el-empty>
<!--        </el-card>-->
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb/index'
import {fetchList} from "@/network/dynamic/progressWork";
import otherNav from '@/components/navBar/otherNav'
export default {
  name: "progressWork",
  components: { breadcrumb,otherNav },
  data() {
    return {
      path: '',
      name: '',
      childName:'',
      childPath:'',
      pageSize: 10,
      page: 1,
      totalPage: 0,
      tableData: [],
      type: 'progressWork',
      formInline:{},
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.path = from.path
      vm.name = '动态';
    })
  },
  mounted() {
    this.getList()
  },

  created() {
    this.childName ='工作进展'
    this.childPath = this.$route.path
  },
  methods: {
    getList() {
      fetchList(Object.assign({
        current: this.page,
        size: this.pageSize,
        type: this.type
      })).then(response => {
        this.tableData = response.data.data.records
        this.totalPage = response.data.data.total
      })
    },
    handleSizeChange(val){
      this.pageSize = val
      this.page = 1
      this.getList()

    },
    handleCurrentChange(val){
      this.page = val
      this.getList()
    },
    onSubmit() {

    },
    handleSelect(key, keyPath) {
      this.$router.push({path:key}).catch(err => {
        // console.log(err)
      })
    },

  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/progressWork";
::v-deep .el-pagination {
  padding: 20px 5px;
  text-align: center;
}
</style>